module.exports = __webpack_public_path__ + "img/arrow2-white.e2bcade3.svg";